import { Component } from '@angular/core';
import {Router}from'@angular/router';
import * as firebase from 'firebase'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {


  constructor(private router:Router) {}

  logout() {
    firebase.auth().signOut();
    this.router.navigateByUrl('/home');
  }
 
}
